// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-717957fa] .apexcharts-reset-icon {\n  margin-left: 2px;\n  padding-top: 2px;\n  width: 16px;\n  height: 16px;\n  cursor: pointer;\n}\n[data-v-717957fa] .apexcharts-reset-icon:hover svg path {\n  fill: #000;\n}\n[data-v-717957fa] .apexcharts-zoom-icon {\n  margin-left: -3px;\n}\n.v-select__selection[data-v-717957fa] {\n  width: 100%;\n  justify-content: center;\n}", ""]);
// Exports
module.exports = exports;
